import { Component, ojs, app, payload } from "modular-openscriptjs";
import { dom } from "../../../fotastart";
import { pageInfo, inform } from "../../../helpers";
import { PAGES } from "../../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

export default class PasswordPage extends Component {

    render(...args) {
        pageInfo(PAGES.CHANGE_PASSWORD);

        return h.div(
            { 
                class: "min-vh-100 py-4 pb-5 mb-5 mx-auto w-100 py-md-5",
                style: "max-width: 500px;"
            },
            h.div(
                { class: "container px-3" },
                
                // Header
                h.div(
                    { class: "mb-4 d-flex align-items-center justify-content-between" },
                    h.div(
                        { class: "d-flex align-items-center gap-3" },
                        h.button(
                            {
                                class: "btn btn-white border shadow-sm circle p-2",
                                onclick: "history.back()",
                            },
                            h.i({ class: "bi bi-arrow-left fs-5 text-secondary" })
                        ),
                        h.h2({ class: "fw-bold mb-0 h4" }, "Change Password")
                    )
                ),

                // Info Alert
                h.div(
                    {
                        class: "alert alert-info border-0 shadow-sm d-flex align-items-start gap-3 p-3 rounded-4 mb-4",
                        style: "background: rgba(13, 202, 240, 0.08); color: #087990;",
                        role: "alert",
                    },
                    h.i({ class: "bi bi-info-circle-fill fs-5 mt-0.5" }),
                    h.div(
                        { class: "small fw-medium" },
                        "If you signed in with a social account (Google, etc.), please use the password sent to your email as your current password."
                    )
                ),

                // Form Card
                h.div(
                    {
                        style: "background: #fff; border-radius: 16px; border: 1px solid rgba(0,0,0,0.08); box-shadow: 0 4px 24px rgba(0,0,0,0.03); padding: 24px;"
                    },
                    h.div(
                        { class: "d-grid gap-3" },

                        // Current Password
                        h.div(
							{ class: "form-field" },
							h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-current-password" }, "Current Password"),
							h.input({
								type: "password",
								name: "current-password",
								class: "form-control p-3 border shadow-none rounded-3 password-input",
								id: "profile-current-password",
								placeholder: "Enter current password"
							})
						),

						// New Password
						h.div(
							{ class: "form-field" },
							h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-new-password" }, "New Password"),
							h.input({
								type: "password",
								name: "new-password",
								class: "form-control p-3 border shadow-none rounded-3 password-input",
								id: "profile-new-password",
								placeholder: "Enter new password"
							})
						),

						// Confirm Password
						h.div(
							{ class: "form-field" },
							h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-confirm-password" }, "Confirm New Password"),
							h.input({
								type: "password",
								name: "confirm-password",
								class: "form-control p-3 border shadow-none rounded-3 password-input",
								id: "profile-confirm-password",
								placeholder: "Confirm new password"
							})
						),

						// Show Password checkbox
						h.div(
							{ class: "form-check" },
							h.input({
								type: "checkbox",
								name: "show-password",
								class: "form-check-input",
								id: "profile-show-password",
								onclick: this.method('showPassword', ['${this}']),
							}),
							h.label({ class: "form-check-label small text-secondary", for: "profile-show-password" }, "Show Passwords")
						),

						// Save Button
						h.div(
							{ class: "d-flex justify-content-end mt-2" },
							h.button(
								{
									type: "button",
									class: "btn btn-primary rounded-pill px-4 py-2.5 fw-bold shadow-sm d-flex align-items-center gap-2",
									onclick: this.method("updatePassword"),
								},
								h.span({}, "Change Password"),
								h.i({ class: "bi bi-check2 fs-5" })
							)
						)
                    )
                )
            ),
            ...args
        );
    }

    updatePassword(){
        let password = dom.id('profile-current-password')?.value;
        let newPassword = dom.id('profile-new-password')?.value;
        let confPassword = dom.id('profile-confirm-password')?.value;

        if (!password) {
            return inform("Current password cannot be empty.", "warning");
        }
        if (!newPassword) {
            return inform("New password cannot be empty.", "warning");
        }
        if (newPassword.length < 8) {
            return inform("New password must be at least 8 characters.", "warning");
        }
        if (newPassword !== confPassword) {
            return inform("Passwords do not match.", "warning");
        }

        broker.broadcast($e.user.needs.password.change, payload({password, newPassword, confPassword}));
    }

    showPassword(elem) {
        let passwords = [
            dom.id('profile-current-password'),
            dom.id('profile-new-password'),
            dom.id('profile-confirm-password'),
        ];

        if(elem?.checked) {
            passwords.forEach(el => el.setAttribute('type', 'text'));
        }
        else {
            passwords.forEach(el => el.setAttribute('type', 'password'));
        }
    }
}

